module.exports = __webpack_public_path__ + "img/t4-m5.547362af.png";